import {getCookies} from 'rlink-utils/Cookies';
import {REGION_COOKIES} from 'rlink-regions/constants';

export default function getUserSelectedCountry () {
  let cookies = getCookies();
  return (REGION_COOKIES.COUNTRY in cookies)
    ? cookies[REGION_COOKIES.COUNTRY]
    : null;
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getUserSelectedCountry.js